import type { ButtonProps } from '@rneui/themed';

export interface IShaButtonProps extends ButtonProps {}
